/*let playButton = $(".page-hero-block__play-btn"),
	videoModal = $(".page-hero-block__modal"),
	videoModalWrapper = $(".page-hero-block__modal-wrapper"),
	videoModalPlayer = $(".page-hero-block__modal-wrapper > video"),
	closeModal = $(".page-hero-block__modal_close");

playButton.on("click", function() {
	$("body").addClass("fix");
	videoModal.fadeIn();
	if (videoModal.hasClass("external-video")) {
		let videoURL = $(".page-hero-block__modal-wrapper .video-container iframe").attr(
			"src"
		);
		videoURL += "&autoplay=1";
		setTimeout(() => {
			$(".page-hero-block__modal-wrapper iframe").attr("src", videoURL);
		}, 400);
	} else {
		videoModalPlayer.get(0).play();
	}
});
closeModal.on("click", function() {
	$("body").removeClass("fix");
	videoModal.fadeOut();
	if (videoModal.hasClass("external-video")) {
		$(".page-hero-block__modal-wrapper iframe").attr(
			"src",
			$(".page-hero-block__modal-wrapper .video-container").attr("data-src")
		);
	} else {
		videoModalPlayer.get(0).pause();
		videoModalPlayer.get(0).currentTime = 0;
	}
});

videoModal.on("click", function(e) {
	if ($(e.target).is(this) || $(e.target).is(videoModalWrapper)) {
		$("body").removeClass("fix");
		videoModal.fadeOut();
		if (videoModal.hasClass("external-video")) {
			$(".page-hero-block__modal-wrapper iframe").attr(
				"src",
				$(".page-hero-block__modal-wrapper .video-container").attr("data-src")
			);
		} else {
			videoModalPlayer.get(0).pause();
			videoModalPlayer.get(0).currentTime = 0;
		}
	}
});*/



// WEBPACK FOOTER //
// ./scripts/modules/page-hero-block.js